import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  Formik,
} from 'formik';
import { useMutation } from '@apollo/client';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import { SAVE_RATING_TESTER } from '../graphql';

import {
  SaveButton,
  ContainerText,
  Modal,
  Content,
  HeaderText,
  ContainerButtons,
  ContainerError,
  Header,
  RatingVideo,
  Form,
  ContainerMultiLine,
  MultiLine,
  TextPrimay,
  Checkbox,
  CancelButton,
} from './styles';

const ModaRating = (props) => {
  const {
    onClose,
    label,
    ratingPrivate,
    ratingDescription,
    rating,
    id,
  } = props;

  const [updateTestSessions] = useMutation(SAVE_RATING_TESTER);

  const submit = async (values, { setStatus, setSubmitting }) => {
    try {
      await updateTestSessions({
        variables: {
          id,
          attributes: {
            rating: values.rating || 0,
            ratingDescription: values.ratingDescription,
            ratingPrivate: values.ratingPrivate || false,
          },
        },
      });
      onClose();
    } catch (error) {
      setSubmitting(false);
      setStatus({ error });
    }
  };

  return (
    <Modal
      open
      size="small"
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
    >
      <Formik
        initialValues={{
          ratingPrivate,
          ratingDescription,
          rating,
        }}
        onSubmit={submit}
      >
        {({
          setFieldValue,
          handleSubmit,
          isSubmitting,
          values,
          status = {},
        }) => (
          <Form onSubmit={handleSubmit}>
            <Content>

              <ContainerText>
                <HeaderText>
                  <Header as="h2">
                    {label}
                  </Header>
                </HeaderText>

                <RatingVideo
                  name="rating"
                  icon="star"
                  maxRating={5}
                  size="large"
                  rating={values.rating}
                  onRate={(e, { rating: newRating }) => {
                    setFieldValue('rating', newRating, false);
                  }}
                />

              </ContainerText>

              <ContainerMultiLine>
                <TextPrimay>Reason for your rating - optional</TextPrimay>

                <Field
                  name="ratingDescription"
                  placeholder="Please be as descriptive as possible"
                  component={MultiLine}
                />

                <Checkbox
                  defaultChecked={values.ratingPrivate}
                  name="ratingPrivate"
                  label="Keep my rating and feedback private"
                  onChange={(e, { checked }) => {
                    setFieldValue('ratingPrivate', checked, false);
                  }}
                />

              </ContainerMultiLine>
              {status && status.error && (
                <ContainerError>
                  <ErrorHandler
                    error={status.error}
                    defaultMessage="Something went wrong while saving."
                  />
                </ContainerError>
              )}
            </Content>

            <ContainerButtons>
              <CancelButton type="button" onClick={onClose} disabled={isSubmitting}>
                Cancel
              </CancelButton>
              <SaveButton type="submit" loading={isSubmitting}>
                Save
              </SaveButton>
            </ContainerButtons>
          </Form>
        )}

      </Formik>
    </Modal>
  );
};

ModaRating.propTypes = {
  onClose: PropTypes.func.isRequired,
  label: PropTypes.string,
  ratingDescription: PropTypes.string,
  ratingPrivate: PropTypes.bool,
  rating: PropTypes.number,
  id: PropTypes.string.isRequired,
};

ModaRating.defaultProps = {
  label: '',
  ratingPrivate: false,
  ratingDescription: '',
  rating: 0,
};

export default ModaRating;
